import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { getMenu, agregaCarro, eliminaDelCarro } from '../actions'
import { connect } from 'react-redux'


class PrecioModulo extends Component{

	constructor(props) {
    	super(props);
      this.state = {
        total:0,
        cantidad:0,
        precio:0,
        precios:[]
      }
      this.calculaPrecio = this.calculaPrecio.bind(this)
      this.agregaAlCarro = this.agregaAlCarro.bind(this)
      this.borraDelCarro = this.borraDelCarro.bind(this)
  }

	componentDidMount() {
    //console.log(this.props.productos)
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.productos.carro_cant != this.state.cantidad){
      this.calculaPrecio(this.props.productos.carro_cant)
    }
  }

  calculaPrecio(cantidad){
    var precio=0
    var cantidadsel=0
    var precios=this.props.productos.prod.precios
    for (var i = 0 ; i < precios.length - 1; i++) {
      if( precios[i].cantidad <= cantidad){
        precio=precios[i].precio
        cantidadsel=precios[i].cantidad
      }else{
        break
      }
    }
    const total = precio * cantidad
    this.setState({
      cantidad,
      precio,
      total:total.toFixed(2)
    })
  }

  borraDelCarro(e) {
    this.props.eliminaDelCarro(this.props.productos.prod.id);
    e.preventDefault()
  }

  agregaAlCarro(e){
    this.props.agregaCarro(this.state.precio)
    this.props.history.push("/carro")
    e.preventDefault()
  }

  render() {
    
    var st =  "productoAcciones  d-none d-sm-none d-md-block  bordeSup "
    
    if(this.props.tipo==2){
      st = "col-md-4 float-right d-block d-sm-block d-md-none"
    }
    
    if(this.props.productos.carro && this.props.productos.carro.length>0){ 
      var cantotal=0   
      this.props.productos.carro.map((prod)=>{
        cantotal=+prod.cantidad
        //console.log(prod.nombre+":"+prod.cantidad)
      })
    }

      return <section className={st}>
          {1 == 2 && <div className="productoData bordeSup">
              <div className="row">
                <div className="producto_precio col-8 col-md-8 mb-3">
                  <div className="row">
                    <div className="col-md-6 text-primary">
                      <i className="fas fa-tag" /> Precio:
                    </div>
                    <div className="col-md-12">
                      1 a 10 {this.props.productos.prod.unicad && this.props.productos.prod.unicad.etiqueta} : $ {this.props.productos.prod.precio_menor}.- <br />
                      Mas de 10 {this.props.productos.prod.unidad_label}: $ {this.props.productos.prod.precio_mayor}.-{" "}
                    </div>
                  </div>
                </div>
                <div className="product_stock col-4 col-md-4 mb-3">
                  {this.props.productos.prod.stock == 1 && <span className="product-meta-title in-stock js-product-stock  text-primary">
                      <i className="fas fa-check-circle" /> <span>
                        En Stock
                      </span>
                    </span>}
                </div>
                <div className="product-meta-shipping  col-md-12 mb-2">
                  <span className="product-meta-title text-primary">
                    <i className="fas fa-truck" /> Envio:
                  </span>
                  <span className="js-ship-date">
                    Te lo enviamos <strong>hoy</strong> "si realizas la compra antes de las 3:00PM"
                  </span>
                </div>
                <div className="product-meta-shipping col-md-12 ">
                  <span className="product-meta-title">
                    <img src="https://www.wristband.com/WristbandResources/media/images/Free-Shipping.png" />
                    <span className="font-black">
                      {" "}
                      En ordenes mayores a
                    </span>
                  </span>
                </div>
              </div>
            </div>}

          <div className="productoAcciones mt-4">
            <div className="row mt-3 mb-3">
              <div className="col-5">
                <span className="js-product-box-count">
                  {this.props.productos.carro_cant}
                </span>

                <span className="text-primary">
                  {this.props.productos.prod.unicad &&
                    this.props.productos.prod.unicad.etiqueta}
                </span>
              </div>

              <div className="col-7">
                <span className="text-primary">Precio Total:</span>
                <span className="">${this.state.total}.-</span>
              </div>
            </div>

            {this.props.productos.prod.custom == 3 && <div className="row">
                <div className="col-12">
                  <a id="" className="btn btn-primary btn-block icon-brush btn-icon-prepend-inner" href="">
                    <i className="fas fa-pencil-alt" /> Personalizar
                  </a>
                </div>
              </div>}

            {this.state.cantidad >= this.props.productos.prod.unicad.min ? this.props.productos.prod.stock === 1 && <div className="row p-0 mt-3">
                  <div className="col-12">
                    <a className="btn btn-primary w-100" href="#" onClick={this.agregaAlCarro}>
                      <i className="fas fa-shopping-cart" /> Agregar al Carro
                    </a>
                  </div>
                </div> : <h6>
                CANTIDAD MINIMA {this.props.productos.prod.unicad.min} {this.props.productos.prod.unicad.etiqueta}
              </h6>}

            {this.props.productos.prod.stock === 0 && <div className="alert alert-danger" role="alert">
                NO HAY EN STOCK
              </div>}

            <div className="row p-0 mt-3">
              <div className="col-12">
                <a className="btn btn-primary w-100" href="#" onClick={this.borraDelCarro}>
                  <i className="fas fa-trash" /> Quita del Carro
                </a>
              </div>
            </div>
            
          </div>
        </section>;
	  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    productos: state.productos
  }
}

const mapDispatchToProps = dispatch => {
  return { getMenu: sector => {
      dispatch(getMenu(sector));
    }, agregaCarro: precio => {
      dispatch(agregaCarro(precio));
    }, eliminaDelCarro: id => {
      dispatch(eliminaDelCarro(id));
    } };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrecioModulo)




// WEBPACK FOOTER //
// ./src/containers/precios_modulo.js